import { css, Theme } from "@emotion/react";

export const MChangePasswordStyle = {
  self: ({ colors }: Theme) => css`
    background-color: ${colors.white};
    padding: 10px;
    height: 100%;
  `,

  formWrapper: css`
    margin-top: 20px;
  `,
  formGroup: css`
    margin-bottom: 12px;

    input {
      background-color: transparent !important;
    }
  `,
  formLabel: ({ colors }: Theme) => css`
    font-size: 14px;
    color: ${colors.black};
    font-weight: bold;
    width: 100%;
    line-height: 1.5;
    margin-bottom: 4px;
    display: inline-block;
  `,

  formBtnWrapper: css`
    display: flex;
    justify-content: center;
    gap: 10px;
  `,
  formBtn: css`
    margin-top: 20px;
    padding: 6px 12px;
    border-radius: 4px;
    color: #333;
    border: 1px solid #ccc;
    font-size: 14px;
    height: unset;
    &:not(:disabled):hover {
      background-color: #e6e6e6;
      color: #333 !important;
      border: 1px solid #ccc !important;
    }
  `,

  alertMsg: css`
    margin-top: 20px;
  `,

  alertInfo: ({ fontSize }: Theme) => css`
    text-align: center;
    color: #31708f;
    background: #d9edf7;
    border: 1px solid #bce8f1;
    padding: 14px;
    border-radius: 8px;
    font-size: ${fontSize[14]};
    svg {
      vertical-align: middle;
      margin-top: -2px;
    }
  `,
};
